export * from "@workspace/gamja-platform/types/pass";
